import { render, staticRenderFns } from "./1_Secteur.vue?vue&type=template&id=ff6ab952&scoped=true&"
import script from "./1_Secteur.vue?vue&type=script&lang=js&"
export * from "./1_Secteur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6ab952",
  null
  
)

export default component.exports